const defaultKicker = (author) => `Совет ${author}:\n%url`

const isDefaultKicker = kicker => {
  return /Совет А. Г.: *\n%url/.test(kicker) || /Совет [А-Я][а-я]+ [А-Я][а-я]+: *\n%url/.test(kicker)
}

module.exports = { defaultKicker, isDefaultKicker }
